import {DatePicker, Form, Modal, Row, Col, Input, Select} from "antd";
import {useFormik} from "formik";
import moment from "moment";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import * as Sentry from "@sentry/react";
import {useStore} from "../../../../hooks/useStore";
import locale from "antd/es/date-picker/locale/tr_TR";

const CreateModal = ({visibility, onCancel}) => {
    const {t} = useTranslation();
    const store = useStore(["paymentManagement"]);
    const [confirmLoading, setConfirmLoading] = useState();

    const formik = useFormik({
        initialValues: {
            startDate: undefined,
            endDate: undefined,
            invoiceDate: undefined,
            paymentDate: undefined,
            periodType: "default"
        },
        validationSchema: yup.object().shape({
            startDate: yup.string().required(t("validation.required", {ns: "common"})),
            endDate: yup.string().required(t("validation.required", {ns: "common"})),
            invoiceDate: yup.string().required(t("validation.required", {ns: "common"})),
            paymentDate: yup.string().required(t("validation.required", {ns: "common"})),
            periodType: yup.string().required(t("validation.required", {ns: "common"}))
        }),
        enableReinitialize: true,
        onSubmit: async values => {
            setConfirmLoading(true);
            try {
                await store.paymentPeriodStore.createPaymentPeriod({
                    startDate: moment(values.startDate).format("YYYY-MM-DD"),
                    endDate: moment(values.endDate).format("YYYY-MM-DD"),
                    invoiceDate: moment(values.invoiceDate).format("YYYY-MM-DD HH:mm"),
                    paymentDate: moment(values.paymentDate).format("YYYY-MM-DD HH:mm"),
                    periodType: values.periodType || "default"
                });
                onCancel(true);
            } catch (error) {
                Sentry.captureException(error);
            } finally {
                setConfirmLoading(false);
            }
        }
    });

    const {values, errors, touched, handleSubmit, setFieldValue} = formik;

    return (
        <Modal
            title={"Yeni Dönem Ekle"}
            visible={visibility}
            onCancel={() => {
                onCancel(false);
            }}
            onOk={handleSubmit}
            confirmLoading={confirmLoading}
            okText={t("modal.saveButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
        >
            <Form labelCol={{span: 24}} wrapperCol={{span: 24}}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            label="Dönem Tipi"
                            //label={t("fields.date", {ns: "common"})}
                            validateStatus={
                                errors.periodType && touched.periodType ? "error" : "success"
                            }
                            help={
                                errors.periodType && touched.periodType ? errors.periodType : null
                            }
                        >
                            <Select
                                name="periodType"
                                data-testid="periodType"
                                value={values.periodType}
                                onChange={value => setFieldValue("periodType", value)}
                            >
                                <Select.Option value="default">
                                    {t("paymentManagement.fields.periodTypes.default", {
                                        ns: "paymentManagement"
                                    })}
                                </Select.Option>
                                <Select.Option value="extra">
                                    {t("paymentManagement.fields.periodTypes.extra", {
                                        ns: "paymentManagement"
                                    })}
                                </Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    label="Başlangıç Tarihi"
                                    //label={t("fields.date", {ns: "common"})}
                                    validateStatus={
                                        errors.startDate && touched.startDate ? "error" : "success"
                                    }
                                    help={
                                        errors.startDate && touched.startDate
                                            ? errors.startDate
                                            : null
                                    }
                                >
                                    <DatePicker
                                        value={values.startDate ? values.startDate : ""}
                                        format={"DD.MM.YYYY"}
                                        onChange={startDate =>
                                            setFieldValue("startDate", startDate)
                                        }
                                        locale={locale}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Bitiş Tarihi"
                                    //label={t("fields.date", {ns: "common"})}
                                    validateStatus={
                                        errors.endDate && touched.endDate ? "error" : "success"
                                    }
                                    help={errors.endDate && touched.endDate ? errors.endDate : null}
                                >
                                    <DatePicker
                                        value={values.endDate ? values.endDate : ""}
                                        format={"DD.MM.YYYY"}
                                        onChange={endDate => setFieldValue("endDate", endDate)}
                                        locale={locale}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>

                    <Col span={24}>
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    label="Son Fatura Kesim Tarihi / Saati"
                                    //label={t("fields.date", {ns: "common"})}
                                    validateStatus={
                                        errors.invoiceDate && touched.invoiceDate
                                            ? "error"
                                            : "success"
                                    }
                                    help={
                                        errors.invoiceDate && touched.invoiceDate
                                            ? errors.invoiceDate
                                            : null
                                    }
                                >
                                    <DatePicker
                                        value={values.invoiceDate ? values.invoiceDate : ""}
                                        format={"DD.MM.YYYY HH:mm"}
                                        showTime
                                        onChange={invoiceDate =>
                                            setFieldValue("invoiceDate", invoiceDate)
                                        }
                                        locale={locale}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="İlk Ödeme Tarihi / Saati"
                                    //label={t("fields.date", {ns: "common"})}
                                    validateStatus={
                                        errors.paymentDate && touched.paymentDate
                                            ? "error"
                                            : "success"
                                    }
                                    help={
                                        errors.paymentDate && touched.paymentDate
                                            ? errors.paymentDate
                                            : null
                                    }
                                >
                                    <DatePicker
                                        value={values.paymentDate ? values.paymentDate : ""}
                                        format={"DD.MM.YYYY HH:mm"}
                                        showTime
                                        onChange={paymentDate =>
                                            setFieldValue("paymentDate", paymentDate)
                                        }
                                        locale={locale}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default CreateModal;
